export const AgentFormEntryType = Object.freeze({
  ACTION: 'ACTION',
  CONFIGURATION: 'CONFIGURATION',
});

// Actions without a configuration name are sorted in among the configurations, not after them.
export default function groupAgentFormActions(actions) {
  const entries = [];
  const configurationEntries = new Map();

  actions.forEach(action => {
    if (!action.integrationName) {
      entries.push({ type: AgentFormEntryType.ACTION, action });
      return;
    }

    let configurationEntry = configurationEntries.get(action.integrationId);
    if (!configurationEntry) {
      configurationEntry = {
        type: AgentFormEntryType.CONFIGURATION,
        integrationId: action.integrationId,
        integrationName: action.integrationName,
        actions: [],
      };
      configurationEntries.set(action.integrationId, configurationEntry);
      entries.push(configurationEntry);
    }
    configurationEntry.actions.push(action);
  });

  configurationEntries.forEach(entry => entry.actions.sort((a, b) => compareLabels(a.name, b.name)));
  return entries.sort((a, b) => compareLabels(getEntryLabel(a), getEntryLabel(b)));
}

function getEntryLabel(entry) {
  return entry.type === AgentFormEntryType.CONFIGURATION ? entry.integrationName : entry.action.name;
}

function compareLabels(a = '', b = '') {
  return a.localeCompare(b, undefined, { sensitivity: 'base' });
}
